import { render, staticRenderFns } from "./BuddhismWorkbench.vue?vue&type=template&id=61a34bad&scoped=true"
import script from "./BuddhismWorkbench.vue?vue&type=script&lang=js"
export * from "./BuddhismWorkbench.vue?vue&type=script&lang=js"
import style0 from "./BuddhismWorkbench.vue?vue&type=style&index=0&id=61a34bad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a34bad",
  null
  
)

export default component.exports